import {
  // UserSelections,
  ExistingPreference,
} from '@aaa-ncnu-ie/digital-api-customer-prefs';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export interface PreferencePolicy {
  policyNumber: string;
  policySourceSystem: string;
}

interface PutPreferencesRequest {
  existingPreferences: ExistingPreference[];
  selections: UserSelection[];
}

export interface UpdatePreferencesArgs {
  authToken: string;
  existingPreferences: ExistingPreference[];
  selections: UserSelection[];
  policies: string;
  customerid: string;
}

export const updatePreferences = async ({
  authToken,
  selections,
  existingPreferences,
  policies,
  customerid,
}: UpdatePreferencesArgs) => {
  const requestBody: PutPreferencesRequest = {
    existingPreferences,
    selections,
  };

  const pendingSelection = selections?.find(
    (selection) =>
      selection.status === 'pending' &&
      (selection.policyDocuments === true ||
        selection.billingAndPayment === true ||
        selection.paymentConfirmation === true ||
        selection.paymentReminders === true)
  );

  const response = await axios.put<any>(
    import.meta.env.VITE_PREFERENCES_URL,
    requestBody,
    {
      headers: {
        policies,
        'Content-Type': 'application/json',
        accept: 'application/json',
        application: 'MYPOLICY_2',
        Authorization: `Bearer ${authToken}`,
        clientid: 'cc_cccm', // need to get this
        customerid,
        reason: 'CUSTOMER_INTERACTION',
        system: 'CUSTPRL', // need to get this
        token: 'NA',
        ...(!pendingSelection && {
          updatedby: 'User',
        }),
        tokentype: 'B2C',
        'x-api-key': import.meta.env.VITE_PREFERENCES_X_API_KEY ?? '',
      },
    }
  );

  return response;
};

export const usePreferencesMutation = () =>
  useMutation({
    mutationFn: (requestBody: UpdatePreferencesArgs) =>
      updatePreferences(requestBody),
    retry: 3,
  });
